import { Injectable } from "@angular/core";
import { DefaultService } from "@core/services/default.service";
import { ColDef } from "ag-grid-community";

@Injectable({
  providedIn: "root",
})
export class CsRegionsService extends DefaultService<number, number, number> {
  getServiceKey(): string {
    return "CsRegionsService";
  }
  constructor() {
    super(`user-service/sync-classifier/cs-regions`);
  }
  columnDefs: ColDef[] = [
    {
      headerName: "GEOGRAPHY.REGIONS.TABLE_HEADERS.ID",
      field: "id",
      maxWidth: 100,
    },
    {
      headerName: "GEOGRAPHY.REGIONS.TABLE_HEADERS.NAME",
      field: "name",
    },
  ];
}
